import { getOrgaoId } from 'utils/auth';
// orgaoSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialOrgaoId = localStorage.getItem('selected_orgao_id');
const isAdmin = getOrgaoId() === '1';

const orgaoSlice = createSlice({
  name: 'orgao',
  initialState: {
    orgaoId: initialOrgaoId || null,
    isAdmin: isAdmin || false,
  },
  reducers: {
    setOrgaoId: (state, action) => {
      state.orgaoId = action.payload;
    },
    clearOrgaoId: (state) => {
      state.orgaoId = null;
    },
    setUserType: (state, action) => {
      state.isAdmin = action.payload.isAdmin;
      if (!action.payload.isAdmin) {
        state.orgaoId = action.payload.orgaoId;
      }
    },
  },
});

export const { setOrgaoId, clearOrgaoId, setUserType } = orgaoSlice.actions;
export default orgaoSlice.reducer;
